import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import * as Redux from 'redux'
import Radium, { StyleRoot } from 'radium';
import {connect} from 'react-redux';
import {RealCampusHdr} from './RealCampusHdr';
import { RealCampusFooter } from './RealCampusFooter';
import * as Request from '../tgccRequest'
import {RealCampusFeedback} from './RealCampusFeedback';


const boxStyle: React.CSSProperties = {
    position: 'relative',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    fontSize:'17px',
    color:'#404041',
    width:'50%',
    margin:'auto'
};

const serviceLiStyle: React.CSSProperties = {
    fontSize:'15px',
    marginBottom:'10px',
    letterSpacing:'1px'
}
const contentDiv:React.CSSProperties = {
    backgroundColor:'white',
    borderBottomRightRadius:'20px',
    borderBottomLeftRadius:'20px',
    minHeight:'350px'
}
const downloadLi: React.CSSProperties = {
    fontSize:'12px',
    marginBottom:'10px',
    color:'#E27558'
}

const cowTagDownStyle: React.CSSProperties = {
    margin:'auto',
    width: '387px',
    backgroundColor:'#5E6A74',
    color:'white',
    padding:'5px',
    height:'40px',
    fontFamily:'BarlowMedium',
    textAlign:'center',
    lineHeight:'2.5em'
}
var paymentBtn = Object.assign({},cowTagDownStyle,{width:'50%',cursor:'pointer',margin:'26px auto',display:'flex', justifyContent:'center',alignItems:'center'});


const dashHdrLineR: React.CSSProperties = {
    width:'180px',
    backgroundColor:'#E9E6E6',
    height:'2px',
    display:'inline-block',
    marginBottom:'8px',
    marginRight:'10px'
}

const dashHdrLineL: React.CSSProperties = {
    width:'180px',
    backgroundColor:'#E9E6E6',
    height:'2px',
    display:'inline-block',
    marginBottom:'8px',
    marginLeft:'5px'
}

const dashText: React.CSSProperties = {
    display:'inline-block',
    letterSpacing:'0.3em',
    fontSize:'26px',
    fontFamily:'Lulo',
    color:'#686868'
}
const hdrCont: React.CSSProperties = {
    textAlign:'center'
}
const link: React.CSSProperties = {
    backgroundColor:'#5E6A74',
    color:'white',
    width:'190px',
    height:'35px',
    fontFamily:'BarlowMedium',
    marginRight:'15px',
    cursor:'pointer',
    padding:'0px 25px',
    fontSize:'13px',
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    border:'1px solid transparent',
    ':hover': {
        backgroundColor:'#B4B5B4',
        color:'white',
        border:'1px solid #B4B5B4'
    }
}
const oneLineLink = Object.assign({},link,{lineHeight:'35px'});

const payDiv: React.CSSProperties = {
    display:'flex',
    flexDirection:'row',
    justifyContent:'center',
    alignItems:'center',
    padding:'10px'
}
const dashHdr: React.CSSProperties = {
    display: 'flex',
    alignSelf:'center',
}
const h: React.CSSProperties = {
    textAlign:'center'
}
const space: React.CSSProperties = {
    minHeight:'350px',
    fontFamily:"BarlowLight",
    width:'60%',
    textAlign:'center',
    margin:'100px auto 50px',
    fontSize:'20px'
}

const cowTagCont: React.CSSProperties = {
    textAlign:'center'
}

class svcProps extends Tgcc.BaseProps{
    proof: Tgcc.Proof;
}
class ApproveState {
    proof: Tgcc.Proof;
    compSelected:string;
}
export class _RealCampusPaymentOptions extends React.Component<svcProps, any> {

    state: ApproveState = new ApproveState;

    init = (login: Tgcc.LoginData) => {
        if(login){
            var proofId = this.props.location.query.proofId;
            Request.getProof(login, proofId, this.proofLoaded, this.loadError);
        }
    }

    componentWillMount(){
        if(this.props.state.LoginData)
            this.init(this.props.state.LoginData);
        else
            Tgcc.LoginUser( this.props.dispatch);
    }
    componentDidMount(){
        var tag = document.getElementById('paymentOptions');
        tag.scrollIntoView(false);
    }
    
    scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
    }
    
    componentWillReceiveProps(props: any){
        if(props.state.LoginData)
            this.init(props.state.LoginData);
    }

    proofLoaded = (proof: Tgcc.Proof) => {
        this.setState({proof: proof});
    }
    loadError = (err: any) => {
        console.log("error loading proof: ", err);
    }
    cancel = () => {
        this.props.dispatch({type: Tgcc.StateAction.DialogAction, payload: null});
    }
    
    showService = (title:string) => {
        this.props.dispatch({type: Tgcc.StateAction.DialogAction, payload:{action: Tgcc.DialogAction.RealCampusServiceContext, payload: { title:title,proof: this.state.proof}}});
    }
    openIndividual = () => {
        this.setState({compSelected:"Individual Payment Link"})   
    }
    openClassic = () => {
        this.setState({compSelected:"Classic Order"})        
    }
    openSignUp = () => {
        this.setState({compSelected:"Individual Sign-Up Link"})
    }
    getIndividual(){
        return(
            <div style={contentDiv}>
                <h2 style={h}>Individual Payment Link</h2>
                <div style={payDiv}>
                    <img src={Tgcc.ResolveUrl('~/images/IPL.3-01.png')} width="40%" height="40%"/>
                    <ul>
                        <li style={serviceLiStyle}>Shareable link that allows for individual purchase &#38; payment</li>  
                        <li style={serviceLiStyle}>Orders are bagged &#38; tagged by name and size for easy distribution</li>
                        <li style={serviceLiStyle}>All Orders are shipped to one location</li>
                        <li style={serviceLiStyle}>We accept Credit/Debit cards, and Venmo</li>
                        <li style={serviceLiStyle}>Additional fees apply for this service</li>
                    </ul>
                </div>
                <div onClick={() => this.showService('Individual Payment Link')}style={paymentBtn} className='mobilePayBtn'>Select Individual Payment Link</div>
            </div>
        )
    }
    getClassic(){
        return (
            <div style={contentDiv}>
                <h2 style={h}>Classic Order</h2>
                <div style={payDiv}>
                    <img src={Tgcc.ResolveUrl('~/images/C-01.png')} width="40%" height="40%"/>
                <ul>
                    <li style={serviceLiStyle}>Standard bulk order. All you need to do is collect and provide the sizes &#38; shipping address for the order. </li>
                    <li style={serviceLiStyle}>Classic orders are organized by size (but bagging  &#38; tagging is available for an additional fee. To utilize this feature, please fill out and send your account manager the cowtag form below)</li>
                    <li style={serviceLiStyle}>All orders are shipped to one location</li>
                    <li style={serviceLiStyle}>We'll send you one invoice for the total order</li>
                </ul>
            </div>
            <div style={cowTagCont}>
                <h3>Would you like your order cowtagged?</h3>
                <a style={cowTagDownStyle} href={Tgcc.ResolveUrl("~/images/Cow_Tag_Form_Collegiate_2018.xls")} download>Download Cow Tag Form</a>
                <p>Additional fees apply for the cowtag service</p>
            </div>

            <div onClick={() => this.showService('Classic Order')}style={paymentBtn} className='mobilePayBtn'>Select Classic Order</div>         
            </div>
        )
    }
    getSignUp() {
        return (
            <div style={contentDiv}>
            <h2 style={h}>Individual Sign-Up Link</h2>
            <div style={payDiv}>
                    <img src={Tgcc.ResolveUrl('~/images/ISL-01.png')} width="40%" height="40%"/>
                <ul>
                    <li style={serviceLiStyle}>The ease of not having to collect sizes, and the simplicity of one payment!</li>
                    <li style={serviceLiStyle}>Orders are bagged &#38; tagged by name and size for easy distribution</li>
                    <li style={serviceLiStyle}>All orders are shipped to one location</li>
                    <li style={serviceLiStyle}>Additional fees apply for the the cowtag service</li>
                </ul>
            </div>
            <div onClick={() => this.showService('Individual Sign-Up Link')}style={paymentBtn} className='mobilePayBtn'>Select Individual Sign-Up Link</div>

            </div>
        )
    }
    getComp(){
        switch(this.state.compSelected){
            case 'Individual Payment Link':
                return this.getIndividual()
            case 'Classic Order':
                return this.getClassic()
            case 'Individual Sign-Up Link':
                return this.getSignUp()
        }
    } 
    getDashHeader(){
        return (
            <div style={hdrCont} className='createAcct'>
                <div style={dashHdrLineR}></div>
                <h1 style={dashText}>Available Payment Options</h1>
                <div style={dashHdrLineL}></div>

            </div>
        )
    }
    getText(sel:string){
        if(this.state.compSelected === sel ){
            return Object.assign({},link,{textDecoration:'underline'})
        }
        else {
            return link
        }
    } 
    ifComp(){
        if(!this.state.compSelected){
            return (
                <div style={space}>Click on each option to learn more information and select your desired payment method.</div>
            )
        }
    }
    
    render() {
        return (
            <div>
            <div id='paymentOptions'></div>
                <RealCampusHdr />
                <RealCampusFeedback state={this.props.state} />
                {this.getDashHeader()}
                <div style={boxStyle} className='mobilePayBox'>
                <div style={dashHdr} className="dashLinkDiv">
                    <div key={1} onClick={this.openIndividual} style={this.getText("Individual Payment Link")}>Individual Payment Link</div>
                    <div key={2} onClick={this.openClassic} style={oneLineLink}>Classic Order</div>
                    <div key={4} onClick={this.openSignUp} style={this.getText("Individual Sign-Up Link")}>Individual Sign-Up Link</div>
                </div>
                {this.getComp()}
                {this.ifComp()}
                

                </div>
                <RealCampusFooter state={this.props.state} />
            </div>           
        )
    }
}

const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { state: state };
};
export var RealCampusPaymentOptions = connect(mapStateToProps)(Radium(_RealCampusPaymentOptions));
